import script from "./Trigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trigger.vue?vue&type=script&setup=true&lang=ts"

import "./Trigger.vue?vue&type=style&index=0&id=864605ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-864605ea"]])

export default __exports__